<div class="activity-feed-content">
  <va-preview-list
    sectionHeader="Activity Feed"
    height="449px"
    [isLoading]="loading"
    [sectionSubHeaderTemplate]="sectionSubHeaderTemplate"
    [dataHeaderTemplate]="headerTemplate"
    [dataRowTemplate]="rowTemplate"
    [headerTabs]="headerTabs"
    [selectedTab]="activityFeedType"
    [data]="data"
    (tabChange)="onChangeActivityFeedType($event)"
    (scroll)="onScroll()"
  ></va-preview-list>

  <ng-template #sectionSubHeaderTemplate>
    <div class="watchlist-holder">
      <app-watchlist-dropdown
        *ngIf="userId && showWatchlist"
        [userId]="userId"
        (selectWatchlistFunc)="selectWatchlistFunc($event)"
      ></app-watchlist-dropdown>
    </div>
  </ng-template>
  <ng-template #headerTemplate let-header="header">
    <div>{{ header.text }}</div>
    <div>{{ header.date }}</div>
  </ng-template>
  <ng-template #rowTemplate let-row="row">
    <div class="icon-col col">
      <va-icon
        size="small"
        isFontAwesome="true"
        [name]="faBell"
        [isFontAwesome]="true"
        *ngIf="row.showBell"
        class="info-icon notificationIconsClass"
        style="vertical-align: -15%;"
      ></va-icon>
      <va-icon
        *ngIf="row.showInfoCircle"
        size="small"
        name="info-circle"
        class="info-icon notificationIconsClass"
        nz-popover
        [nzPopoverContent]="infoTooltipTemplate"
        nzPopoverPlacement="right"
      ></va-icon>
    </div>
    <div class="col company-name">
      <span *ngIf="row.subValues.actor.actor_category == 'COMPANY'">
        <a
          *ngIf="!companyId"
          nz-popover
          [nzPopoverContent]="companyNameTooltipTemplate"
          nzPopoverPlacement="right"
          [routerLink]="['/company/', row.ticker]"
        >
          {{ row.ticker | removeWhiteSpaces }}
        </a>
        <span
          *ngIf="companyId"
          nz-popover
          [nzPopoverContent]="companyNameTooltipTemplate"
          nzPopoverPlacement="right"
        >
          {{ row.ticker | removeWhiteSpaces }}
        </span>
      </span>
      <span *ngIf="row.subValues.actor.actor_category == 'BROKER'">
        <a
          nz-popover
          [nzPopoverContent]="companyNameTooltipTemplate"
          nzPopoverPlacement="right"
          [routerLink]="['/reporting/broker/', row.ticker]"
        >
          {{ row.ticker | removeWhiteSpaces }}
        </a>
      </span>
      <span *ngIf="row.subValues.actor.actor_category == 'ANALYST'">
        <a
          nz-popover
          [nzPopoverContent]="companyNameTooltipTemplate"
          nzPopoverPlacement="right"
          [routerLink]="['/reporting/analyst/', row.actorId]"
        >
          {{ row.ticker | removeWhiteSpaces }}
        </a>
      </span>
    </div>
    <div class="col event-name">
      <span
        *ngIf="
          row.subValues.event_type_id != 3 &&
          row.subValues.event_type_id != 4 &&
          row.subValues.event_display_name != 'Consensus Initiation'
        "
        nz-popover
        [nzPopoverContent]="eventNameTooltipTemplate"
        nzPopoverPlacement="right"
        >{{ row.subValues.event_display_name }}
      </span>
      <span
        class="link-span"
        *ngIf="
          row.subValues.event_type_id == 3 &&
          row.subValues.event_display_name == 'Revision'
        "
        nz-popover
        [nzPopoverContent]="eventNameTooltipTemplate"
        nzPopoverPlacement="right"
        (click)="onClickRevision(row.ticker)"
        >{{ row.subValues.event_display_name }}
      </span>
      <span
        *ngIf="
          row.subValues.event_type_id == 3 &&
          row.subValues.event_display_name == 'Dropped'
        "
        >{{ row.subValues.event_display_name }}
      </span>
      <span
        *ngIf="
          row.subValues.event_type_id == 1 &&
          row.subValues.event_display_name == 'Consensus Initiation'
        "
        nz-popover
        [nzPopoverContent]="eventNameTooltipTemplate"
        nzPopoverPlacement="right"
        >{{ row.subValues.event_display_name }}
      </span>
      <span
        class="link-span"
        *ngIf="row.subValues.event_type_id == 4"
        nz-popover
        [nzPopoverContent]="eventNameTooltipTemplate"
        nzPopoverPlacement="right"
        (click)="onclickDownloadModel(row.subValues)"
        >{{ row.subValues.event_display_name }}
      </span>
    </div>
    <div class="col source-name">
      <span
        *ngIf="row.subValues.object.object_category == 'COMPANY'"
        class="objectClass"
        >{{ row.subValues.object.object_text }}
      </span>
      <span
        *ngIf="
          row.subValues.object.object_category == 'BROKER' ||
          row.subValues.object.object_category == 'BROKER_LIST'
        "
        class="objectClass"
        nz-popover
        [nzPopoverContent]="sourceNameTooltipTemplate"
        nzPopoverPlacement="right"
        >{{ row.subValues.object.object_text }}
      </span>
      <span
        *ngIf="row.subValues.object.object_category == 'ANALYST'"
        class="objectClass"
        >{{ row.subValues.object.object_text }}
      </span>
    </div>
    <div class="col published-time">
      {{ row.publishDate }}
    </div>
    <div class="col alert-info-icon">
      <div
        *ngIf="showAlertPopover && row.subValues.is_alert_enabled !== true"
        class="action-btn color-primary"
        nz-popover
        nzPopoverTitle="Edit Company Alert"
        [(nzPopoverVisible)]="row.subValues.visibleAlerts"
        nzPopoverTrigger="click"
        nzPopoverPlacement="top"
        nzPopoverOverlayClassName="alerts-popover-overlay"
        [nzPopoverContent]="alertsTemplate"
      >
        <va-icon
          size="small"
          name="ellipsis-vertical"
          class="info-icon notificationIconsClass"
        ></va-icon>
      </div>
      <ng-template #alertsTemplate>
        <app-alerts-popover
          [params]="{
            key: row.subValues.actor.actor_text,
            type: 'company'
          }"
          (onSet)="closeAlertsPopover(row.subValues, $event)"
        ></app-alerts-popover>
      </ng-template>
    </div>

    <ng-template #infoTooltipTemplate>
      <div style="max-width: 200px;">
        <p style="font-size: 12px; margin: 0px;">
          Watchlist alert: {{ row.subValues.watchlist_info.join(",") }}
        </p>
      </div>
    </ng-template>
    <ng-template #companyNameTooltipTemplate>
      <div style="max-width: 200px;">
        <p style="font-size: 12px; margin: 0px;">
          {{ row.ticker }}
        </p>
      </div>
    </ng-template>
    <ng-template #eventNameTooltipTemplate>
      <div style="max-width: 200px;">
        <p
          style="font-size: 12px; margin: 0px;"
          *ngIf="row.subValues.event_display_name === 'New Model'"
        >
          A new model is available on
          {{ row.subValues.actor.actor_full_text }} from
          {{ row.subValues.object.object_text }}. Click here to download it.
        </p>
        <p
          style="font-size: 12px; margin: 0px;"
          *ngIf="row.subValues.event_display_name === 'Earnings'"
        >
          {{ row.subValues.actor.actor_full_text }} recently reported earnings.
          Click on the ticker to see current forecasts.
        </p>
        <p
          style="font-size: 12px; margin: 0px;"
          *ngIf="row.subValues.event_display_name === 'Revision'"
        >
          Estimates have been updated on
          {{ row.subValues.actor.actor_full_text }}. Click here to see revision
          analysis
        </p>
        <p
          style="font-size: 12px; margin: 0px;"
          *ngIf="row.subValues.event_display_name === 'Consensus Initiation'"
        >
          {{ row.subValues.event_display_name }}
        </p>
      </div>
    </ng-template>
    <ng-template #sourceNameTooltipTemplate>
      <div style="max-width: 200px;">
        <p style="font-size: 12px; margin: 0px;">
          {{ row.subValues.object.object_full_text }}
        </p>
      </div>
    </ng-template>
  </ng-template>
</div>
